// @flow
import Api from "./index.js";
import type {Publishable, Positions} from "./types.js";
import type {JSONContent} from "./jsontypes.js";
import {normalizeOptions} from "./items.js";

type Container = {
	content: Array<Publishable>;
	positions: Positions;
};

function processPositions(api: Api, container: Container, json: JSONContent): boolean {
	if (!json.content && !json.positions) { return false; }

	const newContent = (json.content && (json.content.items || json.content) || []).map(c => api._registerPublishable(Object.assign(c, { tagfilter: json.tagfilter })));
	const content = newContent.map(content => ({
		type: "publishable",
		content,
		options: normalizeOptions(content),
	}));

	if (json.content.params) {
		if (!container.content) {
			container.content = new Array(json.content.params.total || 0);
		}
		const itemsPerPage = json.content.params.size;
		const start = (json.content.params.page - 1) * itemsPerPage;
		container.content.splice(start, newContent.length, ...newContent);
	} else {
		container.content = newContent;
	}

	if (json.content && (json.type === 'collection' || json.type === 'user' || json.type === 'publisher') && json.content.params && (json.content.params.next || json.content.params.prev)) {
		content.push({
			type: 'pagenav',
			content: json.lookupId || json.id,
			contentType: json.type,
			next: json.content.params.next,
			prev: json.content.params.prev,
			page: json.content.params.page,
		});
	}

	const positions = {};
	const _positions = json.positions || {};
	const keys = Object.keys(_positions);
	for (let i = 0; i < keys.length; i++) {
		const name = keys[i];
		const jsonlist = _positions[name];
		const list = positions[name] = [];
		for (let i = 0; i < jsonlist.length; i++) {
			const item = jsonlist[i];
			if (item.type === "snippet") {
				list.push({
					type: "snippet",
					content: item.content.html.replace(/\r\n/g, "\n"),
					options: (item.options: any) || {},
				});
			} else if (item.type === "publishable") {
				const content = api._registerPublishable(item.content);
				const options = normalizeOptions(content, item.options);
				list.push({
					type: "publishable",
					positioned: true,
					content,
					options,
				});
			} else if (item.type === "menu") {
				list.push({
					type: "menu",
					content: item.content,
				});
			} else if (item.type === "feed") {
				// push all of the standard list
				list.push(...content);

				//TODO: if the content is a partial array insert component here for triggering
				// loading of more content
			}
		}
	}

	if (!positions.main) {
		positions.main = content;
	}

	container.positions = (positions: Positions);
	return true;
}

export default processPositions;



// WEBPACK FOOTER //
// ./lib/api/positions.js